<template>
<div class="chapter">
<div class="inner_page">
<p class="C841"><span class="small"><span id="page_3">SEROTONIN</span></span></p>
<p class="C852">Afterward he would ask her</p>
<p class="C854">what color she saw, what hue</p>
<p class="C862">.   .   .</p>
<p class="C864">of red if she’d come violently</p>
<p class="C854">or green if she’d eased herself down</p>
<p class="C862">.   .   .</p>
<p class="C864">into that limitless trove</p>
<p class="C854">of ecstasies. She’d climb off,</p>
<p class="C862">.   .   .</p>
<p class="C864">his spent member sliding out</p>
<p class="C854">(needle from vein?) and sprawl back</p>
<p class="C862">.   .   .</p>
<p class="C864">with her hands over her eyes:</p>
<p class="C854">I saw white, just white, apples</p>
<p class="C862">.   .   .</p>
<p class="C864">sliced open, white of moths around</p>
<p class="C854">a lamp, my mother’s bath towels</p>
<p class="C862">.   .   .</p>
<p class="C864">folded on a bed. <em>And you?</em></p>
<p class="C862">.   .   .</p>
<p class="C864">Trout-stirred silt in the clear spring’s cress,</p>
<p class="C854">the wide meadowstream canopied</p>
<p class="C862">.   .   .</p>
<p class="C864"><span id="page_4">by</span> May cottonwoods’ full bloom—</p>
<p class="C854">not color so much, then, but</p>
<p class="C862">.   .   .</p>
<p class="C864">a place of vacancy color</p>
<p class="C854">might inhabit: what the eyes looked like</p>
<p class="C862">.   .   .</p>
<p class="C864">before the irises formed,</p>
<p class="C854">the river held in cupped hands—</p>
<p class="C862">.   .   .</p>
<p class="C864">he might have been sleeping by now,</p>
<p class="C854">she might have wondered if this time</p>
<p class="C862">.   .   .</p>
<p class="C864">she would conceive. They would fall</p>
<p class="C854">further apart (privacy</p>
<p class="C862">.   .   .</p>
<p class="C864">of dreams deeper than privacy</p>
<p class="C854">of reveries) before dawn’s wash</p>
<p class="C862">.   .   .</p>
<p class="C864">turned indigo the sky above</p>
<p class="C854">the cobalt mountains, and she</p>
<p class="C862">.   .   .</p>
<p class="C864">would draw her hand along the line</p>
<p class="C854">day had drawn: the same motion</p>
<p class="C862">.   .   .</p>
<p class="C864">the womb-child would months later</p>
<p class="C854">make against her inner-skin,</p>
<p class="C862"><span id="page_5">.   .   .</span></p>
<p class="C864">little ingot, squinting at</p>
<p class="C854">a pale glow just beyond its reach.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Serotoni.vue?fb99cb68